import { render, staticRenderFns } from "./RequestAdditionalAnalysis.vue?vue&type=template&id=453eb4e0&scoped=true"
import script from "./RequestAdditionalAnalysis.vue?vue&type=script&lang=js"
export * from "./RequestAdditionalAnalysis.vue?vue&type=script&lang=js"
import style0 from "./RequestAdditionalAnalysis.vue?vue&type=style&index=0&id=453eb4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453eb4e0",
  null
  
)

export default component.exports